import { Grid, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { createGlobalStyle, styled } from 'styled-components';

import CommonComponentStyle from 'commons/styles/basic-components.styles';

class DNPrintTemplateStyle extends CommonComponentStyle {
  PageWrapper = styled.div`
    padding: 0 8mm 8mm 8mm;
    width: 210mm;
    height: 297mm;
    @media print {
      size: portrait;
      .pagebreak-after {
        page-break-after: always !important;
      }

      .print-barcode {
        display: block;
        page-break-inside: avoid;
      }
    }
  `;

  PageHeader = styled.div`
    margin-top: 8mm !important;
    margin-bottom: 8px;
  `;

  PageHeaderContent = styled(Grid)`
    padding: 8px;
    border: 1px solid black;
  `;

  HeaderSectionWrapper = styled(Grid)`
    padding: 0 8px;
  `;

  DeliveryNoteTitle = styled(Grid)`
    font-weight: 700;
    font-size: 14px;
  `;

  CompanyName = styled(Grid)`
    font-size: 12px;
    padding-bottom: 4px;
  `;

  CompanyAddress = styled(Grid)`
    font-weight: 700;
    font-size: 10px;
  `;

  AWBNumber = styled(Grid)`
    font-weight: 700;
    font-size: 14px;
    padding-bottom: 4px;
  `;

  OrderDate = styled(Grid)`
    font-size: 10px;
    padding-bottom: 4px;
  `;

  DueDate = styled(Grid)`
    font-size: 10px;
    font-weight: 700;
  `;

  DeliveryType = styled(Grid)`
    font-size: 10px;
    font-weight: 700;
    line-height: 1;
    height: 20px;
    align-items: center;
    display: flex !important;
  `;

  CustomerInfo = styled(Grid)`
    font-weight: 700;
    font-size: 10px;
    border: 1px solid black;
    padding: 8px;
  `;

  PageBody = styled.div`
    margin-top: 8px;
    page-break-inside: auto;
  `;

  TableHeadStyle = styled(TableHead)`
    border: 1px solid black;
  `;

  TableHeaderCell = styled(TableCell)`
    font-weight: 700 !important;
    padding: 3px !important;
    line-height: 1.5 !important;
    border: 1px solid black;
    text-align: center !important;
  `;

  TableBodyStyle = styled(TableBody)`
    border: 1px solid black;
  `;

  TableRowStyle = styled(TableRow)`
    height: 12mm !important;
    border: 1px solid black;
  `;

  TableBodyCell = styled(TableCell)`
    line-height: 100% !important;
    padding: 3px !important;
    vertical-align: center !important;
    border: 1px solid black;
    text-align: center !important;
  `;

  InvoiceTableInfo = styled(Grid)`
    font-size: 8px;
    padding: 8px 0;
  `;

  ReturnTableTitle = styled(this.TableHeadStyle)`
    background-color: lightgray;
    .MuiTableCell-root {
      text-align: center;
      font-weight: 700;
    }
  `;

  DNFooterWrapper = styled(Grid)`
    margin-top: 12px !important;
  `;

  SignatureSectionWrapper = styled(Grid)`
    font-size: 10px;
  `;

  SignatureHeader = styled.p`
    margin-bottom: 72px;
  `;

  ReturnCodeTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    font-size: 10px;
  `;

  ReturnCodeTh = styled.th`
    border: 1px solid black;
    padding: 4px;
    text-align: left;
    font-weight: 700;
  `;

  ReturnCodeItemCell = styled.td`
    border: 1px solid black;
    padding: 4px;
    vertical-align: top;
  `;

  CheckboxLabel = styled.p`
    margin: 0;
  `;

  PageFooter = styled.div<{ $pageOffset?: number }>`
    position: absolute;
    bottom: 4mm;
    left: 8mm;
    right: 8mm;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: -${(props) => (props.$pageOffset ? props.$pageOffset * 100 : 0)}vh;
  `;

  PageNumberText = styled.p`
    font-size: 12px;
    margin: 0;
  `;

  DNPrintGlobalStyle = createGlobalStyle`
    @page { size: A4 portrait; margin: 0; }
    body.print-template { margin: 0; padding: 0; }
  `;
}

export default new DNPrintTemplateStyle();
